"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotaryOnDemandClaimOutcome = exports.DayOfWeek = void 0;
/** Same numbering as JavaScript's Date#getDay and moment's day() */
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["sunday"] = 0] = "sunday";
    DayOfWeek[DayOfWeek["monday"] = 1] = "monday";
    DayOfWeek[DayOfWeek["tuesday"] = 2] = "tuesday";
    DayOfWeek[DayOfWeek["wednesday"] = 3] = "wednesday";
    DayOfWeek[DayOfWeek["thursday"] = 4] = "thursday";
    DayOfWeek[DayOfWeek["friday"] = 5] = "friday";
    DayOfWeek[DayOfWeek["saturday"] = 6] = "saturday";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
var NotaryOnDemandClaimOutcome;
(function (NotaryOnDemandClaimOutcome) {
    NotaryOnDemandClaimOutcome["claimed"] = "claimed";
    NotaryOnDemandClaimOutcome["alreadyPaired"] = "alreadyPaired";
    NotaryOnDemandClaimOutcome["queueEmpty"] = "queueEmpty";
    NotaryOnDemandClaimOutcome["notInPool"] = "notInPool";
    NotaryOnDemandClaimOutcome["notAvailable"] = "notAvailable";
    NotaryOnDemandClaimOutcome["scheduledSessionSoon"] = "scheduledSessionSoon";
    /** A booking or another notary held a lock, or won the entry, so the next poll tries again */
    NotaryOnDemandClaimOutcome["retryLater"] = "retryLater";
})(NotaryOnDemandClaimOutcome || (exports.NotaryOnDemandClaimOutcome = NotaryOnDemandClaimOutcome = {}));
